exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.pending-images-pill[data-v-589f11bb] {\r\n    margin-left: 6px;\n}\r\n", ""]);

// exports
